import Vue from 'vue';
import store from "@/store";
import VueI18n from "vue-i18n";
import zh_CN from "@/i18n/lang/zh_CN";
import zh_TW from "@/i18n/lang/zh_TW";
import en_US from "@/i18n/lang/en_US";
import ja_JP from "@/i18n/lang/ja_JP";
import ko_KR from "@/i18n/lang/ko_KR";
import discoveryMessages from '@/i18n/lang/discovery';
import pcMessages from "@/i18n/lang/pc";
import elementCN from "element-ui/lib/locale/lang/zh-CN";
import elementTW from "element-ui/lib/locale/lang/zh-TW";
import elementEN from "element-ui/lib/locale/lang/en";
import elementJA from "element-ui/lib/locale/lang/ja";
import elementKO from "element-ui/lib/locale/lang/ko";

Vue.use(VueI18n)
const defaultLanguage = { text: '中文-繁體', type: 'zh_TW' };
if (!store.state.language?.type || store.state.language.type === 'zh_TW') {
  store.commit('SET_LANGUAGE', defaultLanguage);
}
export default new VueI18n({
    locale: store.state.language?.type || defaultLanguage.type,
    messages: {
        zh_CN: { ...elementCN, ...zh_CN, ...pcMessages.zh_CN, ...discoveryMessages.zh_CN },
        zh_TW: { ...elementTW, ...zh_TW, ...pcMessages.zh_TW, ...discoveryMessages.zh_TW },
        en_US: { ...elementEN, ...en_US, ...pcMessages.en_US, ...discoveryMessages.en_US },
        ja_JP: { ...elementJA, ...ja_JP, ...pcMessages.ja_JP, ...discoveryMessages.ja_JP },
        ko_KR: { ...elementKO, ...ko_KR, ...pcMessages.ko_KR, ...discoveryMessages.ko_KR }
    }
})
